/* globals TweenMax Back Power3 */
export default {
  init() {
    TweenMax.set(".column", {visibility:"visible"});
    TweenMax.staggerFrom(".column", 0.5, {marginTop: '100px', opacity: 0, ease:Power3.easeOut}, 0.25);
    // JavaScript to be fired on the home page
    $('.column').hover(
      // mouse in
      (e) => {
        if($(window).width() > 768){
          const h2 = $(e.currentTarget).find('h2')
          TweenMax.to(h2, 0.5, {marginTop:"-40px", ease: Back.easeOut.config(15) });
        }
      },
        // mouse out
      (e) => {
        if($(window).width() > 768){
          $(e.currentTarget).find('h2').css({'marginTop':0});
        }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHome.js